export default {
  methods: {
    mapLayerLiftopsdesignatedroutesCreeksidegondolaAdd() {
      this.initPollLiftopsdesignatedroutesCreeksidegondola();

      this.map.addSource("liftopsdesignatedroutes-creeksidegondola-source", {
        type: "geojson",
        data: this.computedLiftopsdesignatedroutesCreeksidegondolaGeoJson
      });

      // Stop points source
      this.map.addSource(
        "liftopsdesignatedroutes-creeksidegondolaStoppoints-source",
        {
          type: "geojson",
          data:
            "https://api2.alchemymapping.com/vail/whistler/liftops/stoppoints"
        }
      );

      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/liftops/stop_lift_ops.png",
        (error, image) => {
          if (error) {
            console.log("err img", error);
            return;
          }
          this.map.addImage("icon-stop", image);

          this.map.addLayer({
            filter: ["all", ["in", "Creekside Gondola", ["get", "lift_route"]]],
            id: "creeksidegondola-stop-points",
            type: "symbol",
            source: "liftopsdesignatedroutes-creeksidegondolaStoppoints-source",
            layout: {
              "icon-image": "icon-stop",
              "icon-size": 0.4,
              visibility: "visible"
            }
          });
        }
      );

      this.map.addLayer({
        filter: ["all", ["in", "Creekside Gondola", ["get", "lift_route"]]],
        id: "liftopsdesignatedroutes-creeksidegondola-fatfinger",
        type: "line",
        source: "liftopsdesignatedroutes-creeksidegondola-source",
        paint: {
          "line-color": "Brown",
          "line-width": 20,
          "line-opacity": 0
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", ["get", "dir_travel"], "To"],
          ["in", "Creekside Gondola", ["get", "lift_route"]]
        ],
        id: "liftopsdesignatedroutes-creeksidegondola-to",
        type: "line",
        source: "liftopsdesignatedroutes-creeksidegondola-source",
        paint: {
          "line-color": "#fff301",
          "line-width": 3
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", ["get", "dir_travel"], "From"],
          ["in", "Creekside Gondola", ["get", "lift_route"]]
        ],
        id: "liftopsdesignatedroutes-creeksidegondola-from",
        type: "line",
        source: "liftopsdesignatedroutes-creeksidegondola-source",
        paint: {
          "line-color": "#01fff3",
          "line-width": 3
        }
      });

      this.map.addLayer({
        filter: ["all", ["==", ["get", "label"], "abc123"]],
        id: "liftopsdesignatedroutes-creeksidegondola-hover",
        type: "line",
        source: "liftopsdesignatedroutes-creeksidegondola-source",
        paint: {
          "line-color": "Purple",
          "line-width": 10,
          "line-blur": 2
        }
      });

      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/liftops/arrow_blue.png",
        (error, image) => {
          if (error) {
            console.log("err img", error);
            return;
          }
          this.map.addImage("icon-arrow-blue", image);

          this.map.addLayer({
            filter: [
              "all",
              ["==", ["get", "dir_travel"], "From"],
              ["in", "Creekside Gondola", ["get", "lift_route"]]
            ],
            id: "arrow-blue",
            type: "symbol",
            source: "liftopsdesignatedroutes-creeksidegondola-source",
            layout: {
              "symbol-placement": "line",
              "symbol-spacing": 100,
              "icon-allow-overlap": true,
              "icon-ignore-placement": true,
              "icon-image": "icon-arrow-blue",
              "icon-size": 0.5,
              visibility: "visible"
            }
          });
        }
      );

      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/liftops/arrow_yellow_new.png",
        (error, image) => {
          if (error) {
            console.log("err img", error);
            return;
          }
          this.map.addImage("icon-arrow-orange", image);

          this.map.addLayer({
            filter: [
              "all",
              ["==", ["get", "dir_travel"], "To"],
              ["in", "Creekside Gondola", ["get", "lift_route"]]
            ],
            id: "arrow-orange",
            type: "symbol",
            source: "liftopsdesignatedroutes-creeksidegondola-source",
            layout: {
              "symbol-placement": "line",
              "symbol-spacing": 100,
              "icon-allow-overlap": true,
              "icon-ignore-placement": true,
              "icon-image": "icon-arrow-orange",
              "icon-size": 0.5,
              visibility: "visible"
            }
          });
        }
      );

      this.map.moveLayer(
        "liftopsdesignatedroutes-creeksidegondola-hover",
        "marker-layer-lines"
      );
      this.map.moveLayer(
        "liftopsdesignatedroutes-creeksidegondola-to",
        "marker-layer-lines"
      );
      this.map.moveLayer(
        "liftopsdesignatedroutes-creeksidegondola-from",
        "marker-layer-lines"
      );
      this.map.moveLayer(
        "liftopsdesignatedroutes-creeksidegondola-fatfinger",
        "marker-layer-lines"
      );
    },
    mapLayerLiftopsdesignatedroutesCreeksidegondolaRemove() {
      this.cancelPollLiftopsdesignatedroutesCreeksidegondola();
      this.map.removeImage("icon-arrow-blue");
      this.map.removeImage("icon-arrow-orange");
      this.map.removeImage("icon-stop");
      this.map.removeLayer("arrow-blue");
      this.map.removeLayer("arrow-orange");
      this.map.removeLayer("liftopsdesignatedroutes-creeksidegondola-hover");
      this.map.removeLayer("liftopsdesignatedroutes-creeksidegondola-to");
      this.map.removeLayer("liftopsdesignatedroutes-creeksidegondola-from");
      this.map.removeLayer(
        "liftopsdesignatedroutes-creeksidegondola-fatfinger"
      );
      this.map.removeLayer("creeksidegondola-stop-points");
      this.map.removeSource("liftopsdesignatedroutes-creeksidegondola-source");
      this.map.removeSource(
        "liftopsdesignatedroutes-creeksidegondolaStoppoints-source"
      );
    },
    initPollLiftopsdesignatedroutesCreeksidegondola() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/liftops/designatedroutes",
        dept: "liftopsdesignatedroutes",
        layer: "creeksidegondola",
        token: this.computedAuthToken
      });
      this.pollLiftopsdesignatedroutesCreeksidegondolaInterval = setInterval(
        () => {
          this.$store.dispatch("actionGetGeoJson", {
            url:
              "https://api2.alchemymapping.com/vail/whistler/liftops/designatedroutes",
            dept: "liftopsdesignatedroutes",
            layer: "creeksidegondola",
            token: this.computedAuthToken
          });
        },
        this.computedInterval
      );
    },
    cancelPollLiftopsdesignatedroutesCreeksidegondola() {
      this.pollLiftopsdesignatedroutesCreeksidegondolaInterval = clearInterval(
        this.pollLiftopsdesignatedroutesCreeksidegondolaInterval
      );
    }
  },
  computed: {
    computedLiftopsdesignatedroutesCreeksidegondolaGeoJson() {
      return this.$store.state.mapLayers.liftopsdesignatedroutes.layers
        .creeksidegondola.geojson;
    },
    computedLiftopsdesignatedroutesCreeksidegondolaMapVisibility() {
      return this.$store.state.mapLayers.liftopsdesignatedroutes.layers
        .creeksidegondola.visibility.mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.liftopsdesignatedroutes.layers.creeksidegondola.geojson": {
      handler() {
        if (this.computedLiftopsdesignatedroutesCreeksidegondolaGeoJson) {
          this.mapLayerLiftopsdesignatedroutesCreeksidegondolaRemove();
          this.mapLayerLiftopsdesignatedroutesCreeksidegondolaAdd();
        }
      }
    },
    "$store.state.mapLayers.liftopsdesignatedroutes.layers.creeksidegondola.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerLiftopsdesignatedroutesCreeksidegondolaAdd();
      } else {
        this.mapLayerLiftopsdesignatedroutesCreeksidegondolaRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollLiftopsdesignatedroutesCreeksidegondola();
  }
};
